module.exports = __webpack_public_path__ + "static/media/AP_Normal_Z2.b0656b63.png";